/** The ONE way a refund is named on screen (list, detail, anywhere) so staff can match them. */
export const refundDisplayId = (id: string) => `RFD-${id.slice(-4).toUpperCase()}`;
